module.exports = __webpack_public_path__ + "static/media/chevron-blue.ca13b76c.svg";